<template>
	<div class="workdetails">
		<div class="otitle o1" v-if="mydata.order && mydata.order.trade_no">
			<div>订单编号: {{mydata.order.trade_no}}</div>
			<div>订单状态: {{mydata.order.order_status_str}}</div>
			<div>售后状态: {{mydata.order_service.service_status_str}}</div>
			<div>工单状态: {{mydata.work.work_status_str}}</div>
			<div>等待时间: {{mydata.work.wait_time}}</div>
		</div>

		<div class="otitle" v-if="!mydata.order">
			<div>工单状态: {{mydata.work.work_status_str}}</div>
			<div>等待时间: {{mydata.work.wait_time}}</div>
		</div>

		<div class="table" v-if="mydata.order && mydata.order.trade_no">
			<el-table :data="mydata.order_detail" style="width: 100%" border header-cell-class-name="custom-class">
				<el-table-column prop="product_style_number" label="款号" align="center" header-align="center"
					width="100px">
				</el-table-column>
				<el-table-column prop="product_brand" label="品牌" align="center" header-align="center">
				</el-table-column>
				<!-- <el-table-column label="渠道" align="center" header-align="center">
					<template slot-scope="scope">
						{{mydata.shop.shop_name}}
					</template>
				</el-table-column> -->
				<el-table-column prop="product_size" label="尺码" align="center" header-align="center">
				</el-table-column>
				<el-table-column prop="product_season" label="季度" align="center" header-align="center">
				</el-table-column>
				<el-table-column prop="product_price" label="单价" align="center" header-align="center">
				</el-table-column>
				<el-table-column prop="num" label="下单数量" align="center" header-align="center">
				</el-table-column>
				<el-table-column prop="true_num" label="实发数量" align="center" header-align="center">
				</el-table-column>
			</el-table>
		</div>

		<div :class="!mydata.order? 'item t0':'item'">
			<div class="ohead">
				工单申请信息
			</div>
			<div class="itable">
				<div class="qdtable">
					<div class="lh">工单编号</div>
					<div class="rv">
						{{mydata.work.work_no}}
					</div>
				</div>
				
				<div class="qdtable">
					<div class="lh">问题类型</div>
					<div class="rv">
						{{mydata.work.work_type_str}}
					</div>
				</div>
				
				<div class="qdtable">
					<div class="lh">补偿金额</div>
					<div class="rv bc">
						<span>{{mydata.work.buchang}}</span>
					</div>
				</div>
				
				<div class="qdtable">
					<div class="lh">确认补偿金额</div>
					<div class="rv bc">
						<el-input-number class="num" v-model="num" size="mini" :precision="2" :controls="false" v-if="mydata.work.buchang_confirm == 0 && mydata.work.work_status != 5 && mydata.work.work_status != 4 && onbuchangshow()"></el-input-number>
						<span v-else>{{mydata.work.confirm_buchang}}</span>
						<el-button type="primary" size="mini" v-if="mydata.work.buchang_confirm == 0 && mydata.work.work_status != 5 && mydata.work.work_status != 4 && onbuchangshow()" @click="onbc()">补偿</el-button>
					</div>
				</div>
				
				<div class="qdtable">
					<div class="lh">备注</div>
					<div class="rv">
						{{mydata.work.remark}}
					</div>
				</div>
				
				<div class="qdtable">
					<div class="lh">图片预览</div>
					<div class="rv">
						<div class="imgdiv">
							<el-image class="img" :src="v" :preview-src-list="mydata.work.pics" v-for="(v,k) in mydata.work.pics"
								:key="k">
							</el-image>
						</div>
					</div>
				</div>
				
				<div class="qdtable">
					<div class="lh">申请时间</div>
					<div class="rv">
						{{mydata.work.create_time_str}}
					</div>
				</div>
				
				<!-- 本人 完结工单-->
				<div class="btns" style="margin-top: 10px" v-if="oncancelshow()">
					<el-button type="primary" size="small" @click="oncancel()">完结工单</el-button>
				</div>
			</div>
		</div>
		
		<div class="item" v-if="mydata.log && mydata.log.length >= 2 && k>0" v-for="(v,k) in mydata.log" :key="k">
			<div class="ohead" v-if="v.send_type == 1">
				客户回复信息
			</div>
			
			<div class="ohead" v-if="v.send_type == 2">
				渠道回复信息
			</div>
			
			<div class="ohead" v-if="v.send_type == 3">
				平台回复信息
			</div>
			
			<div class="itable">
				<div class="qdtable">
					<div class="lh">备注</div>
					<div class="rv">
						{{v.remark}}
					</div>
				</div>
				
				<div class="qdtable">
					<div class="lh">回复时间</div>
					<div class="rv">
						{{v.create_time_str}}
					</div>
				</div>
			</div>
		</div>
		
		<div class="item" v-if="onreplyshow()">
			<div class="ohead">
				回复工单
			</div>
			<div class="itable iform">
				<el-form :model="form1" :rules="rules" ref="form1" label-width="140px" class="demo-ruleForm">
					<el-form-item label="备注" prop="remark">
						<el-input type="textarea" v-model="form1.remark" :rows="5" maxlength="500"
							show-word-limit>
						</el-input>
					</el-form-item>
				</el-form>
				
				<div class="btns">
					<el-button type="primary" size="small" @click="onreply()">确认</el-button>
				</div>
			</div>
			
		</div>
		
		
		<div class="item">
			<div class="ohead">
				工单处理进程情况
			</div>
			<div class="itable">
				<el-table :data="mydata.log" style="width: 100%" border header-cell-class-name="custom-class">
					<el-table-column prop="create_time_str" label="操作时间" align="center" header-align="center"
						width="200px">
					</el-table-column>
					<!-- <el-table-column label="操作前状态" align="center" header-align="center"
						width="100px">
					</el-table-column> -->
					<el-table-column prop="operate_type" label="操作内容" align="center" header-align="center">
					</el-table-column>
					<el-table-column prop="remark" label="备注" align="center" header-align="center">
					</el-table-column>
					<el-table-column prop="send_user" label="操作员" align="center" header-align="center"
						width="100px">
					</el-table-column>
				</el-table>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'Workdetails',
		data() {
			return {
				mydata: {
					log: [],
					order: {},
					order_detail: [],
					order_service: {},
					work: {},
				},
				
				type: "",
				
				form1: {
					remark: "",
				},
				
				rules: {
					remark: [{
						required: true,
						message: '请填写备注',
						trigger: 'change'
					}],
				},
				
				num: 0,
			}
		},

		mounted() {
			this.oninfo();
			if (this.$route.path.indexOf("seller") != -1) {
				this.type = "seller";
			} else if (this.$route.path.indexOf("buyer") != -1) {
				this.type = "buyer";
			}
		},

		props: {
			checkobj: {
				type: Object,
				default: {}
			}
		},

		methods: {
			oninfo() {
				var obj = {
					id: this.checkobj.id
				}
				this.$axios.post('api/user/work_info', obj).then(res => {
					if (res.data.code == 0) {
						this.mydata = res.data.data;
						if(this.mydata.work.pics) {
							this.mydata.work.pics = this.mydata.work.pics.split(",");
						}
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},
			
			oncancelshow() {
				if(this.mydata.work.work_status == 5 || this.mydata.work.work_status == 4) {
					return false;
				}
				
				if(this.type == 'buyer') {
					if(this.mydata.work.from_type == 1) {
						return true;
					}else {
						return false;
					}
				}
				
				if(this.type == 'seller') {
					if(this.mydata.work.from_type == 2) {
						return true;
					}else {
						return false;
					}
				}
			},
			
			onreplyshow() {
				if(this.type == 'buyer') {
					if(this.mydata.work.work_status == 1) {
						return true;
					}else {
						return false;
					}
				}
				
				if(this.type == 'seller') {
					if(this.mydata.work.work_status == 2) {
						return true;
					}else {
						return false;
					}
				}
			},
			
			onbuchangshow() {
				if(this.type == 'buyer') {
					if(this.mydata.work.from_type == 2) {
						return true;
					}else {
						return false;
					}
				}
				
				if(this.type == 'seller') {
					return false;
					// if(this.mydata.work.from_type == 1) {
					// 	return true;
					// }else {
					// 	return false;
					// }
				}
			},
			
			onreply() {
				this.$refs['form1'].validate((valid) => {
					if (valid) {
						var send_type = "";
						if(this.type == 'buyer') {
							send_type = 1;
						}
						
						if(this.type == 'seller') {
							send_type = 2;
						}
						
						var obj = {
							id: this.checkobj.id,
							send_type: send_type,
							remark: this.form1.remark
						}
						
						this.$axios.post('api/user/reply_work', obj).then(res => {
							if (res.data.code == 0) {
								this.$message.success('回复成功');
								this.form1.remark = "";
								this.oninfo();
								this.$emit('onload',res.data);
							} else {
								this.$message.error(res.data.message);
							}
						}).catch(err => {
							console.log(err)
						})
					}
				})
			},
			
			oncancel() {
				this.$confirm('是否完结该工单, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					var obj = {
						id:  this.checkobj.id
					}
					this.$axios.post('api/user/cancel_work', obj).then(res => {
						if (res.data.code == 0) {
							this.$message.success('操作成功');
							this.oninfo();
							this.$emit('onload',res.data);
						} else {
							this.$message.error(res.data.message);
						}
					}).catch(err => {
						console.log(err)
					})
				}).catch(() => {})
			},
			
			onbc() {
				var name = "";
				if(this.type == 'buyer') {
					name = "渠道"
				}
				
				if(this.type == 'seller') {
					name = "客户"
				}
				var text = "是否补偿该"+name+", 是否继续?";
				this.$confirm(text, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					var obj = {
						id:  this.checkobj.id,
						confirm_buchang: this.num
					}
					this.$axios.post('api/user/buchang_work', obj).then(res => {
						if (res.data.code == 0) {
							this.$message.success('补偿成功');
							this.oninfo();
							this.num = 0;
							this.$emit('onload',res.data);
						} else {
							this.$message.error(res.data.message);
						}
					}).catch(err => {
						console.log(err)
					})
				}).catch(() => {})
			}
		}
	}
</script>

<style scoped lang="less">
	.otitle {
		width: 100%;
		height: 40px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		border: 1px solid #EBEEF5;
		border-bottom: none;

		div {
			width: 50%;
			height: 40px;
			border-right: 1px solid #EBEEF5;
			display: flex;
			align-items: center;
			justify-content: center;
			font-size: 14px;
			color: #606266;
		}

		div:last-child {
			border-right: none;
		}
	}

	.o1 {
		div {
			width: 17.5%;
		}

		div:first-child {
			width: 30%;
		}
	}

	.item {
		width: 100%;
		margin-bottom: 10px;
		margin-top: 10px;

		.ohead {
			width: 100%;
			height: 40px;
			font-size: 14px;
			font-weight: bold;
			color: #000;
			display: flex;
			align-items: center;
			justify-content: center;
			background-color: #EBEEF5;
			// margin-bottom: 20px;

			span {
				color: #ff4714;
				margin-left: 6px;
			}
		}
		
		.qdtable {
			width: 100%;
			display: flex;
			font-size: 14px;
		
			>div {
				min-height: 40px;
				display: flex;
				align-items: center;
				border-bottom: 1px solid #EBEEF5;
			}
		
			.lh {
				width: 180px;
				min-width: 180px;
				justify-content: center;
				border-right: 1px solid #EBEEF5;
			}
		
			.rv {
				width: 100%;
				padding-left: 10px;
				display: flex;
		
				div {
					width: 50%;
				}
		
				.time {
					padding: 9px;
					border-left: 1px solid #EBEEF5;
		
					p {
						line-height: 20px;
					}
				}
			}
			
			.bc {
				display: flex;
				align-items: center;
				span {
					margin-right: 20px;
				}
			}
		}
	}

	.t0 {
		margin-top: 0;
	}
	
	.img {
		width: 50px !important;
		height: 50px;
		margin-right: 20px;
		padding: 10px 0;
	}
	
	.imgdiv {
		display: flex;
		flex-wrap: wrap;
	}
	
	.btns {
		display: flex;
		justify-content: flex-end;
	}
	
	.iform {
		margin-top: 10px;
	}
	
	/deep/ .num {
		width: 100px !important;
		margin-right: 10px;
		
		.el-input__inner {
			text-align: left !important;
		}
	}
</style>



// WEBPACK FOOTER //
// src/common/workdetails.vue